import { AfterViewInit, Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { Toast } from "primeng/toast";
import { ToastPositionKeys } from "./core/models/messages-keys.enum";
import { LayoutService } from "./core/layout/service/layout.service";
import { WebNotificationService } from "./core/services/web-notifications/web-notification.service";
import { ConfirmationService, PrimeIcons } from "primeng/api";
import { SwUpdate } from "@angular/service-worker";
import { ConfirmDialog } from "primeng/confirmdialog";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmDialog],
  providers: [ConfirmationService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {
  public ToastPositionKeys = ToastPositionKeys;

  constructor(
    // Force the creation of the layoutService at app-root
    // so the themeMode is being set for the /auth and /not-found pages, too.
    private layoutService: LayoutService, // do not delete
    private webNotificationService: WebNotificationService,
    private swUpdate: SwUpdate,
    private confirmationService: ConfirmationService,
  ) {
    this.webNotificationService.handleIncomingMessages();
  }

  ngAfterViewInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().then((updateAvailable) => {
        if (!updateAvailable) return;
        this.confirmationService.confirm({
          header: 'Update available',
          message: 'A new version of this web app is available. Do you want to update?',
          icon: PrimeIcons.INFO_CIRCLE,
          accept: () => {
            window.location.reload();
          },
          rejectButtonProps: {
            label: 'No',
            severity: 'secondary',
            variant: 'outline',
          },
        });
      });
    }
  }
}
